import { render, staticRenderFns } from "./VisioDocuments.vue?vue&type=template&id=3fd90952&scoped=true&"
import script from "./VisioDocuments.vue?vue&type=script&lang=js&"
export * from "./VisioDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd90952",
  null
  
)

export default component.exports